import React from "react";
import { useTranslation } from "react-i18next";

const PulmonaryRehabilitation = () => {
  const { t } = useTranslation("pulmonaryRehabilitation");

  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-12">
            {t("title")}
          </h1>
        </div>

        {/* 呼吸運動 */}
        <section className="mt-12">
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-green-900 mb-4">
              {t("breathing.title")}
            </h2>
            <p className="text-gray-600 mb-6">{t("breathing.description")}</p>
            <div className="space-y-8">
              {/* 腹式呼吸練習 */}
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-4">
                  {t("breathing.diaphragmatic.title")}
                </h3>
                <ul className="list-disc list-inside space-y-2 text-gray-600">
                  {[1, 2, 3].map((item) => (
                    <li key={item}>
                      {t(`breathing.diaphragmatic.items.item${item}`)}
                    </li>
                  ))}
                </ul>
              </div>

              {/* 噘嘴呼吸練習 */}
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-4">
                  {t("breathing.pursed.title")}
                </h3>
                <ul className="list-disc list-inside space-y-2 text-gray-600">
                  {[1, 2].map((item) => (
                    <li key={item}>
                      {t(`breathing.pursed.items.item${item}`)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* 咳嗽練習 */}
        <section className="mt-12">
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-green-900 mb-4">
              {t("coughing.title")}
            </h2>
            <p className="text-gray-600 mb-6">{t("coughing.description")}</p>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              {[1, 2, 3].map((item) => (
                <li key={item}>{t(`coughing.items.item${item}`)}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* 姿勢引流 */}
        <section className="mt-12">
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-green-900 mb-4">
              {t("postural.title")}
            </h2>
            <p className="text-gray-600 mb-6">{t("postural.description")}</p>
            <div className="space-y-4">
              <div>
                {/* <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("postural.principles.title")}
                </h3> */}
                <ul className="list-disc list-inside space-y-2 text-gray-600">
                  <li>{t("postural.principles.position")}</li>
                  <li>{t("postural.principles.duration")}</li>
                  <li>{t("postural.principles.timing")}</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* 胸部叩擊 */}
        <section className="mt-12">
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-green-900 mb-4">
              {t("percussion.title")}
            </h2>
            <p className="text-gray-600 mb-6">{t("percussion.description")}</p>
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("percussion.handPosition.title")}
                </h3>
                <p className="text-gray-600">
                  {t("percussion.handPosition.description")}
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("percussion.timing.title")}
                </h3>
                <p className="text-gray-600">
                  {t("percussion.timing.duration")}
                </p>
                <p className="text-gray-600">
                  {t("percussion.timing.frequency")}
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("percussion.precautions.title")}
                </h3>
                <ul className="list-disc list-inside space-y-2 text-gray-600">
                  {[1, 2, 3].map((item) => (
                    <li key={item}>
                      {t(`percussion.precautions.items.item${item}`)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="mt-12 text-gray-600 bg-white shadow rounded-lg p-6">
          {t("data_source_title")}
          <a
            href="https://reurl.cc/rE7Rek"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 underline"
          >
            {t("data_source")}
          </a>
        </section>
      </div>
    </div>
  );
};

export default PulmonaryRehabilitation;
